import React from 'react';
import { i18n } from 'config/locales';
import { Summary, DateSummary } from 'components/Summary';

import { LEGAL, LEGAL_INVESTIGATIONS_HISTORY } from 'config/formSections/legal';
import Subsection from 'components/Section/shared/Subsection';
import connectSubsection from 'components/Section/shared/SubsectionConnector';
import { EmptyListInstance } from 'forms/shared/models';
import Branch from 'components/Form/Branch';
import Show from 'components/Form/Show';
import Accordion from 'components/Form/Accordion';
import { isPVQForm } from 'helpers/form';
import HistoryItem from './HistoryItem';
import ClearanceHistoryItem from './ClearanceHistoryItem';

const sectionConfig = {
  key: LEGAL_INVESTIGATIONS_HISTORY.key,
  section: LEGAL.name,
  store: LEGAL.store,
  subsection: LEGAL_INVESTIGATIONS_HISTORY.name,
  storeKey: LEGAL_INVESTIGATIONS_HISTORY.storeKey,
};

export class History extends Subsection {
  constructor(props) {
    super(props);

    const {
      section, subsection, store, storeKey
    } = sectionConfig;

    this.section = section;
    this.subsection = subsection;
    this.store = store;
    this.storeKey = storeKey;
    this.handleError = this.handleError.bind(this);
  }

  update = (queue) => {
    this.props.onUpdate(this.storeKey, {
      List: this.props.List,
      HasHistory: this.props.HasHistory,
      ClearanceHistoryList: this.props.ClearanceHistoryList,
      HasClearanceHistory: this.props.HasClearanceHistory,
      ...queue,
    });
  };

  updateList = (values) => {
    this.update({
      List: values,
    });
  };

  updateBranch = (values) => {
    this.update({
      HasHistory: values,
      List: values.value === 'Yes' ? this.props.List : [],
    });
  };

  updateClearanceHistoryList = (values) => {
    this.update({
      ClearanceHistoryList: values,
    });
  };

  updateClearanceHistoryBranch = (values) => {
    this.update({
      HasClearanceHistory: values,
      ClearanceHistoryList: values.value === 'Yes' ? this.props.ClearanceHistoryListList : [],
    });
  };

  summary = (item, index) => {
    const o = (item && item.Item) || {};
    const dates = DateSummary(o.Granted);
    const agency = (o.Agency || {}).value || '';

    return Summary({
      type: i18n.t('legal.investigations.history.collection.item'),
      index,
      left: agency,
      right: dates,
      placeholder: i18n.t('legal.investigations.history.collection.unknown'),
    });
  };

  clearanceHistorySummary = (item, index) => {
    const o = (item && item.Item) || {};
    const agency = (o.Agency || {}).value || '';

    return Summary({
      type: i18n.t('legal.pvq.investigations.clearancehistory.collection.item'),
      index,
      left: agency,
      placeholder: i18n.t('legal.pvq.investigations.clearancehistory.collection.unknown'),
    });
  };

  render() {
    const { requireLegalInvestigationClearanceGranted, errors } = this.props;
    const accordionErrors = errors && errors.filter((e) => e.indexOf('List.accordion') === 0);
    const clearanceAccordionErrors = errors && errors.filter((e) => e.indexOf('ClearanceHistoryList.accordion') === 0);
    const isPVQ = isPVQForm(this.props.formType);

    return isPVQ ? (
      <div
        className="section-content investigations-history"
        data-section={LEGAL.key}
        data-subsection={LEGAL_INVESTIGATIONS_HISTORY.key}
      >
        <h1 className="section-header">{i18n.t('legal.subsection.investigations.history')}</h1>
        <Branch
          name="has_history"
          label={i18n.t('legal.pvq.investigations.history.heading.title')}
          labelSize="h4"
          className="legal-investigations-history-has-history"
          {...this.props.HasHistory}
          warning
          onError={this.handleError}
          required={this.props.required}
          onUpdate={this.updateBranch}
          scrollIntoView={this.props.scrollIntoView}
          attribute="HasHistory"
          showDNK
        />

        {this.props.HasHistory.value === 'Yes'

          && (
          <Accordion
            {...this.props.List}
            defaultState={this.props.defaultState}
            scrollToBottom={this.props.scrollToBottom}
            summary={this.summary}
            onUpdate={this.updateList}
            onError={this.handleError}
            errors={accordionErrors}
            description={i18n.t('legal.pvq.investigations.history.collection.description')}
            appendTitle={i18n.t('legal.pvq.investigations.history.collection.appendTitle')}
            appendLabel={i18n.t('legal.pvq.investigations.history.collection.appendLabel')}
            required={this.props.required}
            scrollIntoView={this.props.scrollIntoView}
            attribute="List"
          >
            <HistoryItem
              name="Item"
              bind
              required={this.props.required}
              scrollIntoView={this.props.scrollIntoView}
              requireLegalInvestigationClearanceGranted={requireLegalInvestigationClearanceGranted}
              attribute="List"
              formType={this.props.formType}
            />
          </Accordion>
          )}

        <Branch
          {...this.props.HasClearanceHistory}
          name="has_clearancehistory"
          label={i18n.t('legal.pvq.investigations.clearancehistory.heading.title')}
          labelSize="h4"
          className="legal-investigations-history-has-history"
          warning
          onError={this.handleError}
          required={this.props.required}
          onUpdate={this.updateClearanceHistoryBranch}
          scrollIntoView={this.props.scrollIntoView}
          attribute="HasClearanceHistory"
          showDNK
        />

        {this.props.HasClearanceHistory.value === 'Yes'
          && (
          <Accordion
            {...this.props.ClearanceHistoryList}
            defaultState={this.props.defaultState}
            scrollToBottom={this.props.scrollToBottom}
            summary={this.clearanceHistorySummary}
            onUpdate={this.updateClearanceHistoryList}
            onError={this.handleError}
            errors={clearanceAccordionErrors}
            description={i18n.t('legal.pvq.investigations.clearancehistory.collection.description')}
            appendTitle={i18n.t('legal.pvq.investigations.clearancehistory.collection.appendTitle')}
            appendLabel={i18n.t('legal.pvq.investigations.clearancehistory.collection.appendLabel')}
            required={this.props.required}
            scrollIntoView={this.props.scrollIntoView}
            attribute="ClearanceHistoryList"
          >
            <ClearanceHistoryItem
              name="Item"
              bind
              required={this.props.required}
              scrollIntoView={this.props.scrollIntoView}
              attribute="List"
              formType={this.props.formType}
            />
          </Accordion>
          )}
      </div>
    ) : (
      <div
        className="section-content investigations-history"
        data-section={LEGAL.key}
        data-subsection={LEGAL_INVESTIGATIONS_HISTORY.key}
      >
        <h1 className="section-header">{i18n.t('legal.subsection.investigations.history')}</h1>
        <Branch
          {...this.props.HasHistory}
          name="has_history"
          label={i18n.t('legal.investigations.history.heading.title')}
          labelSize="h4"
          className="legal-investigations-history-has-history"
          warning
          onError={this.handleError}
          required={this.props.required}
          onUpdate={this.updateBranch}
          scrollIntoView={this.props.scrollIntoView}
          attribute="HasHistory"
        />

        <Show when={this.props.HasHistory.value === 'Yes'}>
          <Accordion
            {...this.props.List}
            defaultState={this.props.defaultState}
            scrollToBottom={this.props.scrollToBottom}
            summary={this.summary}
            onUpdate={this.updateList}
            onError={this.handleError}
            errors={accordionErrors}
            description={i18n.t('legal.investigations.history.collection.description')}
            appendTitle={i18n.t('legal.investigations.history.collection.appendTitle')}
            appendLabel={i18n.t('legal.investigations.history.collection.appendLabel')}
            required={this.props.required}
            scrollIntoView={this.props.scrollIntoView}
            attribute="List"
          >
            <HistoryItem
              name="Item"
              bind
              required={this.props.required}
              scrollIntoView={this.props.scrollIntoView}
              requireLegalInvestigationClearanceGranted={requireLegalInvestigationClearanceGranted}
              attribute="List"
            />
          </Accordion>
        </Show>
      </div>
    );
  }
}

History.defaultProps = {
  name: 'history',
  HasHistory: {},
  HasClearanceHistory: {},
  List: EmptyListInstance,
  ClearanceHistoryList: EmptyListInstance,
  defaultState: true,
  onUpdate: () => { },
  onError: (value, arr) => arr,
  section: 'legal',
  subsection: 'investigations/history',
  dispatch: () => { },
  scrollToBottom: '',
  errors: [],
};

export default connectSubsection(History, sectionConfig);
